<template>
  <div v-bind="$attrs" class="ui-button-group" :class="`ui-button-group--${orientation}`">
    <slot />
  </div>
</template>
<script setup lang="ts">
  import { provide, toRef } from 'vue'

  import { type ButtonColor, type ButtonVariant, buttonGroupKey } from '../Button/context'

  defineOptions({ inheritAttrs: false })
  const props = withDefaults(
    defineProps<{
      color?: ButtonColor
      orientation?: 'horizontal' | 'vertical'
      variant?: ButtonVariant
    }>(),
    { orientation: 'horizontal' },
  )
  provide(buttonGroupKey, {
    get color() {
      return toRef(props, 'color').value
    },
    get variant() {
      return toRef(props, 'variant').value
    },
  })
</script>
<style scoped>
  .ui-button-group {
    display: inline-flex;
    isolation: isolate;
  }

  .ui-button-group--vertical {
    flex-direction: column;
  }

  .ui-button-group :deep(.ui-button:focus-visible) {
    z-index: 1;
  }

  .ui-button-group--horizontal :deep(.ui-button:not(:first-child)) {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .ui-button-group--horizontal :deep(.ui-button:not(:last-child)) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .ui-button-group--vertical :deep(.ui-button:not(:first-child)) {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .ui-button-group--vertical :deep(.ui-button:not(:last-child)) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
</style>
